



























import { Component, Mixins, Watch, Emit, Prop } from "vue-property-decorator";
import { Patient } from "../../../domain/patient";
import { PatientFinderMixin } from "./mixins";
import { DuplicatedPatientIndicator } from "..";
import { BrowserKinds, BrowserUtility } from "../../../utilities";

@Component({
  components: {
    DuplicatedPatientIndicator,
  }
})
export default class FoundPatientSelector extends Mixins(PatientFinderMixin) {
  @Prop({ default: true })
  isPatientNoInputtable: boolean;

  data(): any {
    return {
      isFocused: false,
    };
  }
  isFocused: boolean;

  get isIe(): boolean {
    return (BrowserUtility.getBrowserKind() === BrowserKinds.InternetExplorer);
  }

  get isNameEnable(): boolean {
    return this.$configuration.behavior.patient.finder.name.isEnable;
  }

  @Watch("isFinding")
  onIsFindingUpdated(newValue: boolean, oldValue: boolean): void {
    if (newValue !== oldValue) {
      this.changeFinding(newValue);
    }
  }

  @Watch("patient")
  onPatientUpdated(newValue: Patient, oldValue: Patient): void {
    this.selectPatient();
  }

  @Watch("isFocused")
  onChangeFocused(newValue: boolean, oldValue: boolean): void {
    if (newValue !== oldValue) {
      this.changeFocused(newValue);
    }
  }

  @Emit()
  changeFinding(value: boolean): any {}

  @Emit()
  changeFocused(value: boolean): any {}

  enterKeyDown(): void {
    // Enter押下でフォーカスが残ってるとフォーカス外れた時に再度検索が実行されるのでEnter押下時はフォーカスを外すだけにする.
    const element = this.$refs.patientId as HTMLElement;
    element.blur();
  }

  blurInput(): void {
    this.isFocused = false;
    if (this.edittingId === "") {
      this.clearPatient();
      return;
    }
    this.findPatient();
  }

  focusInput(): void {
    this.isFocused = true;
  }

  onDuplicatedPatientSelected(patient: Patient): void {
    this.edittingId = patient.id;
    this.patient = patient;
  }

  onKeyPressed(event: KeyboardEvent): void {
    if (!this.isIe || !this.isNumberOnly) { return; }

    const allowedKeys = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
    if (!allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  onPasted(event: ClipboardEvent) {
    if (!this.isIe || !this.isNumberOnly) { return; }

    event.preventDefault();
    
    const win = window as Window & {
      clipboardData?: {
        getData: (type: string) => string;
      };
    };

    const pastedText = win.clipboardData ? win.clipboardData.getData("Text") : "";
    const numbersOnlyText = pastedText.replace(/\D/g, "");
    this.edittingId += numbersOnlyText;
  }
}
